import { Story } from '../../DocTypes';

export const horizontalTemplateStory: Story = {
  title: 'Horizontal template',
  description: 'List with templated items that flow horizontally',
  coreComponent: {
    html: `<tag-list item-container-style='{"display": "inline-flex", "border": "0"}'>
    <template>
      <div>
        <tag-text text='{{name}}' text-style='{"text-align": "center"}'></tag-text>
        <tag-progress-donut value='{{passRate}}' width='100px'></tag-progress-donut>
      </div>
    </template>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { passRate: 77, name: 'Jordan Pickford' },
      { passRate: 44, name: 'Kyle Walker' },
      { passRate: 89, name: 'Harry Maguire' },
      { passRate: 99, name: 'Jordan Henderson' },
    ]);
  });
    `,
  },
  reactWrapper: {
    jsx: `<TagList
    itemContainerStyle={{display: "inline-flex", border: "0"}}
    renderItem={({name, passRate}) => (
      <div>
        <TagText text={name} textStyle={{textAlign: "center"}}></TagText>
        <TagProgressDonut value={passRate} width='100px'></TagProgressDonut>
      </div>
    )}
    data={[
      { passRate: 77, name: 'Jordan Pickford' },
      { passRate: 44, name: 'Kyle Walker' },
      { passRate: 89, name: 'Harry Maguire' },
      { passRate: 99, name: 'Jordan Henderson' },
    ]}
  />`,
  },
};
